import { Component, inject, input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { SchoolFacade } from '@app/store/school';

@Component({
    selector: 'app-delete-button',
    templateUrl: './delete-button.component.html',
    styleUrls: ['./delete-button.component.css'],
    imports: [TranslateModule, ButtonModule],
})
export class DeleteButtonComponent {
    private readonly schoolFacade = inject(SchoolFacade);
    private readonly confirmationService = inject(ConfirmationService);
    private readonly translateService = inject(TranslateService);

    readonly schoolId = input.required<string>();
    readonly saving = input<boolean>(false);
    readonly testId = input.required<string>();

    onDelete(): void {
        this.confirmationService.confirm({
            header: this.translateService.instant('schools.delete.header'),
            message: this.translateService.instant('schools.delete.message'),
            icon: 'pi pi-exclamation-triangle',
            rejectButtonProps: {
                label: this.translateService.instant('schools.delete.reject'),
                severity: 'secondary',
                outlined: true,
            },
            acceptButtonProps: {
                label: this.translateService.instant('schools.delete.accept'),
                severity: 'danger',
            },
            accept: () => {
                this.schoolFacade.deleteSchool(this.schoolId());
            },
        });
    }
}
